module.exports = __webpack_public_path__ + "img/tysl.a9801ff8.png";